import { render } from "./CaretDown.vue?vue&type=template&id=dd3337b8"
import script from "./CaretDown.vue?vue&type=script&lang=js"
export * from "./CaretDown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__